export const LOCAL_STORAGE_TOKEN_KEY = 'spradlingPortalToken';
export const LOCAL_STORAGE_TOKEN_EXPIRATION_KEY = 'spradlingPortalTokenExpiration';
export const LOCAL_STORAGE_CONTACT_CREATED_KEY = 'spradlingContactCreated';
export const LOCAL_STORAGE_CART_ID = 'spradlingCartId';